import Checkbox from '../../../components/Form/Checkbox/Checkbox';
import { Updater } from '../../../hooks/useImmer';
import { useTranslation } from '../../../i18n/i18n';
import { ApiSchedule } from '../../../types';
import { DaysOrderKey, isWeekendDay, parseWeeklyDays, sortDays, stringifyWeeklyDays } from '../utils';

interface WeekPatternFormProps {
	schedule: ApiSchedule;
	setSchedule: Updater<ApiSchedule>;
}

export const WeekPatternForm = ({ schedule, setSchedule }: WeekPatternFormProps): JSX.Element => {
	const t = useTranslation().subscriptions;

	const addWeekDay = (id: DaysOrderKey, draft: ApiSchedule): DaysOrderKey[] =>
		parseWeeklyDays(draft.weeklyDays).concat([id]).sort(sortDays);

	const removeWeekDay = (id: number, draft: ApiSchedule): DaysOrderKey[] =>
		parseWeeklyDays(draft.weeklyDays)
			.filter((r) => r !== id)
			.sort(sortDays);

	const selected = parseWeeklyDays(schedule.weeklyDays) ?? [];

	const onWeekdayChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
		const id = parseInt(e.target.id) as DaysOrderKey;

		setSchedule((draft) => {
			if (e.target.checked) {
				draft.weeklyDays = stringifyWeeklyDays(addWeekDay(id, draft));
			} else {
				draft.weeklyDays = stringifyWeeklyDays(removeWeekDay(id, draft));
			}
		});
	};

	return (
		<>
			<p>{t.schedule.repeatOn}</p>
			<div className="checkbox-grid">
				{/*
				 * No new saturdays or sundays: the calendar that picks the start date refuses both and
				 * nothing leaves the warehouse then, so "every saturday" was an order we could not
				 * send. One that is already set stays on screen, though - hiding it would leave a
				 * schedule firing on a day the customer can no longer untick.
				 */}
				{Object.values(t.schedule.weekdays)
					.filter(({ id }) => !isWeekendDay(id) || selected.includes(id as DaysOrderKey))
					.sort((a, b) => sortDays(a.id as DaysOrderKey, b.id as DaysOrderKey))
					.map(({ id, text }) => (
						<Checkbox
							key={id}
							id={id + ''}
							checked={selected.includes(id as DaysOrderKey)}
							label={text}
							onChange={onWeekdayChange}
						/>
					))}
			</div>
		</>
	);
};
